module.exports = __webpack_public_path__ + "img/incentive_img03.b86aeec5.jpg";